import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import FormField from '@cloudscape-design/components/form-field'

const defaultMaskOptions = {
    prefix: '$',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 10, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
}
    
export type MonetaryInputProps = {
    label: string,
    value: string, 
    onChange: (newValue: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly: boolean, 
    [rest: string]: any,
}

export default ({ label, value, onChange, validate, readOnly, ...rest }: MonetaryInputProps) => {

    // if (readOnly) {
    //     return (
    //         <div>
    //             {label + ': '}
    //             <b style={{width: '100px'}}>{value}</b>
    //         </div> 
    //     ) 
    // }
    const currencyMask = createNumberMask(defaultMaskOptions)
    const valid = (!readOnly && validate) ? validate(value, label) : true

    return (
        <FormField label={label} info={!validate ? 'Optional' : ''} >
            <MaskedInput className="money" readOnly={readOnly}
                mask={currencyMask}  inputMode="numeric"
                value={value}
                onChange={e => onChange(e.target.value)}
                required={!readOnly ? (!validate ? false : true) : false}
                {...rest}
            />
        </FormField> 
    )
}

      // Phone number mask
      // mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
